export enum MeetingFilterType {
  TITLE = "TITLE",
}

export enum MeetingFilterOperator {
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  EXACT = "EXACT",
  NOT_EXACT = "NOT_EXACT",
  REGEX = "REGEX",
  NOT_REGEX = "NOT_REGEX",
}

export enum MeetingFilterMatchType {
  ALL = "ALL",
  ANY = "ANY",
  NONE = "NONE",
}

export interface MeetingFilterRule {
  id: string;
  ruleGroupId: string;
  filterType: MeetingFilterType;
  operator: MeetingFilterOperator;
  pattern: string;
  createdAt: string;
  updatedAt: string;
}

export interface MeetingFilterRuleGroup {
  id: string;
  userId: string;
  matchType: MeetingFilterMatchType;
  order: number;
  rules: MeetingFilterRule[];
  createdAt: string;
  updatedAt: string;
}
